// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

function ClickToPayNotYou(props) {
  var getVisaCards = props.getVisaCards;
  var setIsShowClickToPayNotYou = props.setIsShowClickToPayNotYou;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var setClickToPayConfig = match$1[1];
  var clickToPayConfig = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setIdentifier = match$2[1];
  var identifier = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setIsValid = match$3[1];
  var isValid = match$3[0];
  var match$4 = React.useState(function () {
        return "EMAIL_ADDRESS";
      });
  var setIdentifierType = match$4[1];
  var identifierType = match$4[0];
  var updateCtpNotYouState = function (consumerIdentity) {
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.clickToPayCards = [];
          return newrecord;
        });
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.consumerIdentity = consumerIdentity;
          return newrecord;
        });
    setIsShowClickToPayNotYou(function (param) {
          return false;
        });
  };
  var onBack = function (param) {
    setIsShowClickToPayNotYou(function (param) {
          return false;
        });
  };
  var countryAndCodeCodeList = Utils$OrcaPaymentPage.getArray(Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.phoneNumberJson), {}), "countries");
  var countryCodes = countryAndCodeCodeList.map(function (countryObj) {
        var countryObjDict = Utils$OrcaPaymentPage.getDictFromJson(countryObj);
        var countryCode = Utils$OrcaPaymentPage.getString(countryObjDict, "phone_number_code", "");
        var countryName = Utils$OrcaPaymentPage.getString(countryObjDict, "country_code", "");
        return {
                code: countryCode,
                countryISO: countryName
              };
      });
  var match$5 = React.useState(function () {
        return Core__Option.getOr(countryCodes[0], ClickToPayHelpers$OrcaPaymentPage.defaultCountry).countryISO;
      });
  var setCountryCode = match$5[1];
  var countryCode = match$5[0];
  var formatPhoneNumber = function (value) {
    if (value.startsWith("+")) {
      if (value.includes(" ")) {
        return value;
      } else {
        return value.replace(/^\+(\d{1,3})(\d+)$/, "+$1 $2");
      }
    } else if (Core__Option.isSome(Caml_option.nullable_to_opt(value.match(/^\d+$/)))) {
      return "+" + value;
    } else {
      return value;
    }
  };
  var handleInputChange = function (ev) {
    var target = ev.target;
    var newValue = target.value;
    var formattedValue = identifierType === "MOBILE_PHONE_NUMBER" ? formatPhoneNumber(newValue) : newValue;
    setIdentifier(function (param) {
          return formattedValue;
        });
  };
  var handleTypeChange = function (ev) {
    var target = ev.target;
    var newValue = target.value;
    setIdentifierType(function (param) {
          return newValue;
        });
    setIdentifier(function (param) {
          return "";
        });
  };
  var handleCountryCodeChange = function (ev) {
    var target = ev.target;
    var newValue = target.value;
    setCountryCode(function (param) {
          return newValue;
        });
  };
  var handlePhoneInputChange = function (ev) {
    var target = ev.target;
    var newValue = target.value.replace(/\\D/g, "");
    setIdentifier(function (param) {
          return newValue;
        });
  };
  React.useEffect((function () {
          setIsValid(function (param) {
                var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                var phoneRegex = /^\d{6,14}$/;
                if (identifierType === "EMAIL_ADDRESS") {
                  return emailRegex.test(identifier);
                } else {
                  return phoneRegex.test(identifier);
                }
              });
        }), [
        identifier,
        identifierType
      ]);
  var handleSubmit = function (e) {
    e.preventDefault();
    if (!isValid) {
      return ;
    }
    var country = Core__Option.getOr(countryCodes.find(function (country) {
              return countryCode === country.countryISO;
            }), ClickToPayHelpers$OrcaPaymentPage.defaultCountry);
    var submittedIdentifier = identifierType === "MOBILE_PHONE_NUMBER" ? country.code.slice(1) + " " + identifier : identifier;
    var consumerIdentity = {
      identityType: identifierType,
      identityValue: submittedIdentifier
    };
    var match = clickToPayConfig.clickToPayProvider;
    switch (match) {
      case "VISA" :
          updateCtpNotYouState(consumerIdentity);
          ((async function () {
                  setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.visaComponentState = "CARDS_LOADING";
                        return newrecord;
                      });
                  try {
                    await ClickToPayHelpers$OrcaPaymentPage.signOutVisaUnified();
                    return await getVisaCards(consumerIdentity.identityValue, "", consumerIdentity.identityType);
                  }
                  catch (exn){
                    return setClickToPayConfig(function (prev) {
                                var newrecord = Caml_obj.obj_dup(prev);
                                newrecord.visaComponentState = "NONE";
                                return newrecord;
                              });
                  }
                })());
          return ;
      case "MASTERCARD" :
          Core__Promise.$$catch(ClickToPayHelpers$OrcaPaymentPage.signOut().finally(function () {
                    updateCtpNotYouState(consumerIdentity);
                  }), (function (err) {
                  return Promise.resolve({
                              TAG: "Error",
                              _0: err
                            });
                }));
          return ;
      case "NONE" :
          return ;
      
    }
  };
  return React.createElement("div", {
              className: "p-4 bg-white rounded-lg border border-[#E6E1E1] flex flex-col space-y-4"
            }, React.createElement("div", {
                  className: "flex flex-col"
                }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: !props.isCTPAuthenticateNotYouClicked,
                      children: React.createElement("button", {
                            onClick: onBack
                          }, React.createElement(Icon$OrcaPaymentPage.make, {
                                name: "arrow-back",
                                size: 16
                              }))
                    }), React.createElement("div", {
                      className: "flex justify-center items-center"
                    }, React.createElement("div", undefined, React.createElement(ClickToPayHelpers$OrcaPaymentPage.SrcMark.make, {
                              "card-brands": clickToPayConfig.availableCardBrands.join(","),
                              height: "32"
                            })))), React.createElement("div", {
                  className: "flex flex-col justify-center items-center space-y-4 px-4"
                }, React.createElement("p", {
                      className: "text-sm font-normal"
                    }, "Enter a new email or mobile number to access a different set of linked cards."), React.createElement("form", {
                      className: "w-full flex flex-col justify-center items-center space-y-4",
                      onSubmit: handleSubmit
                    }, React.createElement("div", {
                          className: "w-full flex space-x-2"
                        }, React.createElement("div", {
                              className: "relative w-1/3"
                            }, React.createElement("select", {
                                  className: "w-full p-3 pr-10 border border-gray-300 rounded-md appearance-none",
                                  value: ClickToPayHelpers$OrcaPaymentPage.getIdentityType(identifierType),
                                  onChange: handleTypeChange
                                }, React.createElement("option", {
                                      value: ClickToPayHelpers$OrcaPaymentPage.getIdentityType("EMAIL_ADDRESS")
                                    }, "Email"), React.createElement("option", {
                                      value: ClickToPayHelpers$OrcaPaymentPage.getIdentityType("MOBILE_PHONE_NUMBER")
                                    }, "Phone")), React.createElement("div", {
                                  className: "absolute inset-y-0 right-4 flex items-center selection:pointer-events-none"
                                }, React.createElement(Icon$OrcaPaymentPage.make, {
                                      name: "arrow-down",
                                      size: 10,
                                      className: "absolute z-10 pointer pointer-events-none"
                                    }))), identifierType === "EMAIL_ADDRESS" ? React.createElement("input", {
                                className: "w-2/3 p-3 border border-gray-300 rounded-md",
                                placeholder: "Enter email",
                                required: true,
                                type: "text",
                                value: identifier,
                                onChange: handleInputChange
                              }) : React.createElement("div", {
                                className: "w-2/3 flex border border-gray-300 rounded-md overflow-hidden"
                              }, React.createElement("div", {
                                    className: "relative"
                                  }, React.createElement("select", {
                                        className: "h-full p-3 appearance-none focus:outline-none",
                                        value: countryCode,
                                        onChange: handleCountryCodeChange
                                      }, countryCodes.map(function (country) {
                                            return React.createElement("option", {
                                                        key: country.code + "-" + country.countryISO,
                                                        value: country.countryISO
                                                      }, country.countryISO + " " + country.code);
                                          })), React.createElement("div", {
                                        className: "absolute inset-y-0 right-4 flex items-center selection:pointer-events-none"
                                      }, React.createElement(Icon$OrcaPaymentPage.make, {
                                            name: "arrow-down",
                                            size: 10,
                                            className: "absolute z-10 pointer pointer-events-none"
                                          }))), React.createElement("input", {
                                    className: "flex-grow p-3 focus:outline-none w-full",
                                    placeholder: "Mobile number",
                                    required: true,
                                    type: "tel",
                                    value: identifier,
                                    onChange: handlePhoneInputChange
                                  }))), React.createElement("button", {
                          className: "w-full p-3 " + (
                            isValid ? "" : "opacity-50 cursor-not-allowed"
                          ),
                          style: {
                            backgroundColor: themeObj.buttonBackgroundColor,
                            color: themeObj.buttonTextColor,
                            fontSize: themeObj.buttonTextFontSize,
                            borderRadius: themeObj.buttonBorderRadius
                          },
                          disabled: !isValid,
                          type: "submit"
                        }, "Switch ID"))));
}

function ClickToPayNotYou$ClickToPayNotYouText(props) {
  var setIsShowClickToPayNotYou = props.setIsShowClickToPayNotYou;
  var onNotYouClick = function (param) {
    setIsShowClickToPayNotYou(function (param) {
          return true;
        });
  };
  return React.createElement("div", {
              className: "flex space-x-2 text-sm text-[#484848]"
            }, React.createElement("button", {
                  className: "underline cursor-pointer [text-underline-offset:0.2rem]",
                  onClick: onNotYouClick
                }, "Not you?"));
}

var ClickToPayNotYouText = {
  make: ClickToPayNotYou$ClickToPayNotYouText
};

var make = ClickToPayNotYou;

export {
  make ,
  ClickToPayNotYouText ,
}
/* react Not a pure module */
